import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './Redux/Store';

const kalniyojanroot = ReactDOM.createRoot(document.getElementById('kalniyojanroot'));
kalniyojanroot.render(
  <Provider store={store}>
    <App />
  </Provider>
);
